import React from 'react';

import { formatIndexDate } from '../services/utils';

class Statusbar extends React.Component {

    checkAndRound(n) {
        return (typeof n == 'number') ? n.toFixed(4) : '';
    }

    renderFreights(freight_ids) {
        let freights = this.props.freights;
        return freights
            .filter(freight => freight_ids.indexOf(freight.id) > -1)
            .map(freight => `${freight.title}${freight.price ? ' ' + freight.currency + freight.price.toFixed(2) : ''}`).join(', ')
    }

    renderIndex() {
        let { statusbar } = this.props; 
        let date = statusbar.data.created_date ? formatIndexDate(statusbar.data.created_date, true) : '';

        return (
            <span>
                Index on {date} =&nbsp;
                {statusbar.params.currency || ''} {this.checkAndRound(statusbar.data.index)}&nbsp;
                { statusbar.data.indexChange ?
                    '('+(statusbar.data.indexChange >= 0 ? 'Up' : 'Down')+' '+
                    this.checkAndRound(statusbar.data.indexChange)+')'
                : null }
            </span>
        )
    }

	render() {
        const { statusbar, absolutePosition, inactive, freights } = this.props;
              
        if (!statusbar || !statusbar.params ) return false;
        
        const { visible, data, params } = statusbar;
        const absoluteClass = absolutePosition ? 'absolutePosition ' : '';
        const inactiveClass = inactive ? 'inactive' : '';
        const shouldShow = visible && (
            (params.contract_type !== 'Physical' && 'index' in data) ||
            (freights && freights.length && params.contract_type === 'Physical' && params.freights && params.freights.length)
        );
        
		return (
            <div className={'statusbar ' + absoluteClass + inactiveClass}
                style={{display: (shouldShow ? 'block' : 'none') }}>
                {params.contract_type !== 'Physical' ?
                    this.renderIndex()
                : null}
                {params.contract_type === 'Physical' ?
                    this.renderFreights(params.freights)
                : null}
            </div>
		)
	}
}

export default Statusbar;



// WEBPACK FOOTER //
// ./source/components/statusbar.js